import { render, staticRenderFns } from "./LocalchainView.vue?vue&type=template&id=a4b1e798&scoped=true&"
import script from "./LocalchainView.vue?vue&type=script&lang=js&"
export * from "./LocalchainView.vue?vue&type=script&lang=js&"
import style0 from "./LocalchainView.vue?vue&type=style&index=0&id=a4b1e798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b1e798",
  null
  
)

export default component.exports